import styled from "styled-components";
import {devices} from '../../../components/MediaQuerys/BreakpointsAndDevices'

export const Acuarela = styled.img`
    width: auto;
    margin: 0 auto;
    height: auto;
    border-radius: 20px;
    display: none;
    /* border-radius: 0 0 1em 1em; */
    @media only screen and ${devices.mobileM} {
        width: 375px;
        /* height: 375px; */
        
    }
    @media only screen and ${devices.mobileL} {
        width: auto;
        
    }
    @media only screen and ${devices.laptopL}{
        width: 1440px;
        display: grid;

    }

    @media only screen and ${devices.laptop}{
        /* width: 80%; */
        display: grid;       

    }

`
export const Separador = styled.img`
    width: 100%;
    display: none;
    margin-top: -14em;
    height: auto;
    @media only screen and ${devices.laptopL}{
        width: 1440px;
        display: block;

    }

    @media only screen and ${devices.laptop}{
        /* width: 80%; */
        display: block;       

    }
`